module.exports = __webpack_public_path__ + "img/ENplus_small.bda4309.png";